export interface ContaBancaria {
  id: number;
  banco: string;
  agencia: string;
  conta: string;
  tipo: string;
  titular: string;
  cpf: string;
  chavePix: string;
  tipoPix: 'cpf' | 'email' | 'celular' | 'aleatoria';
  principal: boolean;
}

export const contasBancariasIniciais: ContaBancaria[] = [
  {
    id: 1,
    banco: 'Banco do Brasil',
    agencia: '1234-5',
    conta: '12345-6',
    tipo: 'Corrente',
    titular: 'João Silva Santos',
    cpf: '123.456.789-00',
    chavePix: '123.456.789-00',
    tipoPix: 'cpf',
    principal: true,
  },
  {
    id: 2,
    banco: 'Nubank',
    agencia: '0001',
    conta: '98765-4',
    tipo: 'Conta PIX',
    titular: 'João Silva Santos',
    cpf: '123.456.789-00',
    chavePix: 'joao.silva@email.com',
    tipoPix: 'email',
    principal: false,
  },
  {
    id: 3,
    banco: 'Itaú',
    agencia: '5678',
    conta: '11223-3',
    tipo: 'Conta PIX',
    titular: 'João Silva Santos',
    cpf: '123.456.789-00',
    chavePix: '+55 (11) 99999-8888',
    tipoPix: 'celular',
    principal: false,
  },
  {
    id: 4,
    banco: 'Inter',
    agencia: '0001',
    conta: '55443-2',
    tipo: 'Conta PIX',
    titular: 'João Silva Santos',
    cpf: '123.456.789-00',
    chavePix: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
    tipoPix: 'aleatoria',
    principal: false,
  },
];
